import { render, staticRenderFns } from "./InterfaceChart.vue?vue&type=template&id=13a9f2c4&scoped=true&"
import script from "./InterfaceChart.vue?vue&type=script&lang=js&"
export * from "./InterfaceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a9f2c4",
  null
  
)

export default component.exports